export const parseStoreNameArgs = (
  storeFieldName: string,
  fieldName: string,
) => {
  const argsJson = storeFieldName.split(fieldName + ':')[1];
  return JSON.parse(argsJson);
};
